<template>
  <div>
    <div class="message">
      <div class="header">
        <!-- <div class="position pull-left">
          {{ position }}
        </div> -->
        <div class="originator">{{ topic.name }}</div>
      </div>
      <div class="clearfix"></div>
      <div class="message-content">
        <!-- <div>{{ topic.name }}</div> -->
      </div>
    </div>
    <div class="message-tools"></div>
  </div>
</template>

<script>
export default {
  name: 'Topic',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    topic: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    position() {
      return this.index + 1;
    },
  },
  mounted() {
    // this.updateHeight();
  },
  methods: {
    updateHeight() {
      // Height plus padding
      this.height = this.$el.offsetHeight + 12;
      this.$emit('heightUpdated', [this.id, this.height]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

video {
  height: 370px;
}

.originator {
  font-size: 28px;
  margin-top: 10px;
  font-weight: bold;
}

.time {
  font-size: 11px;
  color: #90949c;
}

.avatar img {
  margin-right: 10px;
}

.message {
  .position {
    height: 40px;
    width: 40px;
    padding-top: 10px;
    text-align: center;
    background-color: pink;
    border-radius: 20px;
  }
  .originator {
    font-size: 16px;
    padding-top: 10px;
    padding-left: 20px;
    font-weight: bold;
  }
  .channel-type {
    background-color: #4267b2;
    color: #ffffff;
    font-size: 10px;
    width: 16px;
    height: 16px;
  }
  .originator-type {
    display: inline-block;
    background-color: #4267b2;
    color: #fff;
    font-size: 8px;
    width: 12px;
    height: 12px;
    text-align: center;
  }
  .time {
    font-size: 11px;
    color: #90949c;
  }
  .message-content {
    margin-top: 10px;

    img {
      border: 1px solid #eee;
      width: 100%;
    }
  }
  .audio-container {
    text-align: center;
  }
  .video-container {
    text-align: center;
  }
  .images-container {
    height: 370px;
  }
  .audio-container,
  .images-container,
  .video-container {
    margin-top: 8px;
  }
}

.message-tools {
  width: 100%;
  padding-top: 10px;

  i.fa {
    font-size: 16px;
    font-weight: normal;
    margin-right: 2px;
  }

  i.fa:last-child {
    margin-right: 0;
  }

  a {
    color: #bbb;
    margin-right: 20px;
  }
  a:hover {
    color: $colony-primary;
    background-color: inherit;
  }
}

.interact {
  margin-top: 8px;
  margin-bottom: -13px;
}

.comments,
.replies {
  margin-left: -15px;
  margin-right: -15px;
  padding: 0 15px 15px 15px;
}

.comments {
  background-color: lighten(#8a7dc5, 33%);
}

.replies {
  background-color: lighten(#a176c1, 33%);
}

.read-more {
  font-size: 0.9em;
  margin: 5px 0;
}

.sent-by {
  color: #90949c;
  font-size: 0.8em;
}

.onair-input,
.reply-input,
.comment-input {
  margin-top: 8px;

  .input-controls {
    margin-top: 3px;
  }
}

.onair-input {
  .el-select {
    width: 100%;
  }
}

.comments-and-replies {
  text-align: right;
  a {
    color: #493894;
  }
}
</style>

<style lang="scss">
.hashtag {
  color: #a6307d;
}
.mention {
  color: #493894;
}
</style>



// WEBPACK FOOTER //
// Topic.vue?f0a9b836